import React from 'react'
import { NavLink } from 'react-router-dom'

const LinkButton = ({ icon, to, label, color = 'prime' }) => {
  return (
    <NavLink
      to={to || '/'}
      className={`bg-${color} font-medium !text-white  px-6 py-3 rounded-lg ${
        icon ? ' flex  gap-1.5 items-center' : ''
      }`}
    >
      {icon ? icon : ''}
      {label}
    </NavLink>
  )
}

export default LinkButton
